import { render, staticRenderFns } from "./editRecord.vue?vue&type=template&id=94d1d66e"
import script from "./editRecord.vue?vue&type=script&lang=js"
export * from "./editRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports